import { memo } from 'react';
import { Box, ImageProps } from '@chakra-ui/react';

// import branchIcon from './assets/branch-icon.svg';
// import chevronDownIcon from './assets/chevron-down-icon.svg';
// import listTreeIcon from './assets/list-tree-icon.svg';
// import wrenchIcon from './assets/wrench-icon.svg';
// import ChevronDownIcon from 'components/Icons/ChevronDownIcon';

import ChevronDownIconV1 from 'components/Icons/ChervonDownIconv1';

import BranchIcon from './assets/BranchIcon';
import WrenchIcon from './assets/WrenchIcon';
import ListTreeIcon from './assets/ListtreeIcon';

const ICON_SRC = {
  branch: <BranchIcon />,
  listTree: <ListTreeIcon />,
  chevronDown: <ChevronDownIconV1 />,
  wrench: <WrenchIcon />,
} as const;

export type BuilderModeSvgIconName = keyof typeof ICON_SRC;

const ICON_SIZE = {
  branch: { w: 16, h: 16 },
  listTree: { w: 16, h: 16 },
  chevronDown: { w: 9, h: 6 },
  wrench: { w: 16, h: 16 },
} as const;

interface BuilderModeSvgIconProperties extends Omit<ImageProps, 'src' | 'name'> {
  name: BuilderModeSvgIconName;
}

const BuilderModeSvgIcon = memo(({ name }: BuilderModeSvgIconProperties) => {
  const size = ICON_SIZE[name];
  return (
    <Box
      w={`${size.w}px`}
      h={`${size.h}px`}
      minW={`${size.w}px`}
      minH={`${size.h}px`}
      flexShrink={0}
    >
      {ICON_SRC[name]}
    </Box>
  );
});

BuilderModeSvgIcon.displayName = 'BuilderModeSvgIcon';

export default BuilderModeSvgIcon;
